import { useRouter } from "next/router"
import useStore from "components/ui/Context"
import { getAccessToken } from "lib/Cookies"
import { useEffect, useRef, useState } from "react"
import LoginAlert from "components/ModalLogin/LoginAlert"
import DisplayTypeScreenBlock from "utils/DisplayTypeScreenBlock"
import CardHorizontal from "components/TypeCard/CardHorizontal"
import CardVertical from "components/TypeCard/CardVertical"
import { Modal } from "components/ui"
export default function App(props) {
  const router = useRouter()
  const { toggleModalLogin, userInfo, signKey } = useStore()
  const { status, id, type, is_live, is_protected, display_type } = props
  const isMonter = useRef(false)
  const [isModal, setIsModal] = useState(false)

  function onClick(e) {
    if (is_protected && !getAccessToken()) {
      isMonter.current = true
      setIsModal(true)
      // toggleModalLogin()
      e.preventDefault()
      return false
    }
  }

  function onClose() {
    setIsModal(false)
  }

  function onNext() {
    toggleModalLogin()
    setIsModal(false)
  }

  useEffect(() => {
    if (isMonter.current && userInfo?.fullname) {
      router.push(`/video?id=${id}&type=${type}`)
    }
  }, [userInfo])

  useEffect(() => {
    if (isMonter.current && signKey) {
      router.push(`/video?id=${id}&type=${type}`)
    }
  }, [signKey])

  if (status === "live" || !is_live) {
    return (
      <>
        <div onClick={onClick}>
          <CardHorizontal {...props} nextLink={`/video?id=${id}&type=${type}`} />
        </div>
        <Modal
          isOpen={isModal}
          onCancel={() => {
            setIsModal(false)
          }}
          showIcon={false}
        >
          <LoginAlert
            onCancel={() => {
              setIsModal(false)
            }}
            onNext={onNext}
          />
        </Modal>
      </>
    )
  } else {
    return (
      <>
        {display_type === DisplayTypeScreenBlock.HORIZONTAL ? (
          <CardHorizontal {...props} nextLink={`/video?id=${id}&type=${type}`} />
        ) : (
          <CardVertical {...props} nextLink={`/video?id=${id}&type=${type}`} />
        )}
      </>
    )
  }
}
